var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEocErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 10.5V16.3333",
    stroke: "#D32F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 24.9772H6.93C2.88167 24.9772 1.19 22.0839 3.15 18.5489L6.79 11.9922L10.22 5.83219C12.2967 2.08719 15.7033 2.08719 17.78 5.83219L21.21 12.0039L24.85 18.5605C26.81 22.0955 25.1067 24.9889 21.07 24.9889H14V24.9772Z",
    stroke: "#D32F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9932 19.832H14.0036",
    stroke: "#D32F2F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEocErrorIcon);
export default __webpack_public_path__ + "static/media/eoc-error-icon.59dbb3d6fead5edbd583b807f6ff4413.svg";
export { ForwardRef as ReactComponent };